import { configureStore } from "@reduxjs/toolkit"
import navigationSlice from '@/store/slices/navigationSlice'
import userSlice from '@/store/slices/userSlice'
import authSlice from '@/store/slices/authSlice'
import lookupSlice from '@/store/slices/lookupSlice'
import entitySchemaSlice from '@/store/slices/entitySchemaSlice'
import remindersSlice from '@/store/slices/remindersSlice'
import announcementsSlice from '@/store/slices/announcementsSlice'

export const store = configureStore({
  reducer: {
    navigation: navigationSlice,
    user: userSlice,
    auth: authSlice,
    lookup: lookupSlice,
    entitySchema: entitySchemaSlice,
    reminders: remindersSlice,
    announcements: announcementsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
